module.exports = __webpack_public_path__ + "img/modal-burger-single.02ab4cd5.svg";